import React from 'react'

export const DetailIntention = ({ item }) => {
    return (
        <div>
            <div className="font-mtn">
                <div className="bg-white p-3 rounded-lg border">
                    <div className="px-4 sm:px-0">
                        <h3 className="lg:text-lg text-2xl text-gray-900 font-bold">
                            Ticket N°{item.numeroTicket}
                        </h3>
                    </div>
                    <div className="mt-3 border-t border-gray-100">
                        <dl className="divide-y divide-gray-100">
                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold text-gray-900">
                                    Client
                                </dt>
                                <dd className="mt-1 text-sm font-medium leading-6  sm:col-span-2 sm:mt-0">
                                    {item?.client.nomPrenoms}
                                </dd>
                            </div>

                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Email
                                </dt>
                                <dd className="mt-1 text-sm font-medium leading-6  sm:col-span-2 sm:mt-0">
                                    {item?.client.email}                                </dd>
                            </div>
                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Contact client
                                </dt>
                                <dd className="mt-1 text-sm font-medium leading-6 sm:col-span-2 sm:mt-0">
                                    {item?.client.numero}
                                </dd>
                            </div>
                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Numero avantage
                                </dt>
                                <dd className="mt-1 text-sm font-medium leading-6 sm:col-span-2 sm:mt-0">
                                    {item?.numeroMtn}
                                </dd>
                            </div>
                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Batiment
                                </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                    {item?.batiment.designation}

                                </dd>
                            </div>

                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Equipement
                                </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                    {item?.equipement.designation}

                                </dd>
                            </div>

                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Ville du client
                                </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                    {item?.commune}

                                </dd>
                            </div>
                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Quartier
                                </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                    {item?.quartier}

                                </dd>
                            </div>

                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Status d'éligibilité
                                </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                    {item?.eligibilite?.ftthEligible === 'yes' ? 'Eligible' : 'Pas eligible'}
                                </dd>
                            </div>

                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Forfait souhaité
                                </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                    {item?.forfait?.designation}
                                </dd>
                            </div>

                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Categorie de forfait
                                </dt>
                                <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                    {item?.forfait?.categorie?.replace('_', "").toLowerCase()}
                                </dd>
                            </div>

                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold text-gray-900">
                                    Date de création
                                </dt>
                                <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                    {item.dateCreation ? new Date(item.dateCreation).toLocaleDateString() : "--"}
                                </dd>
                            </div>
                        </dl>
                    </div>
                </div>
            </div>
            <div className="">
                <p className="my-4 font-bold text-lg">Information sur l'agent </p>
                <div className="bg-white p-3 rounded-lg border">
                    <div className="">
                        <dl className="divide-y divide-gray-100">



                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Nom et prenoms
                                </dt>
                                <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                    {item?.agent.nomPrenoms}
                                </dd>
                            </div>

                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Numero de téléphone
                                </dt>
                                <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                    {item?.agent.numero}
                                </dd>
                            </div>

                            <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                <dt className="text-sm font-semibold leading-6 text-gray-900">
                                    Type d'agent
                                </dt>
                                <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                    {item?.agent?.typeAgent?.replace(/_/g, " ").toLowerCase()}
                                </dd>
                            </div>

                        </dl>
                    </div>
                </div>
            </div>
        </div>
    )
}
